// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__oCa6L","total":"Cart_total__TDnoJ","actions":"Cart_actions__vzyad","button--alt":"Cart_button--alt__MSJG3","button":"Cart_button__8FmV+"};